import { render, staticRenderFns } from "./NotificationTray.vue?vue&type=template&id=4e137687"
import script from "./NotificationTray.vue?vue&type=script&lang=js"
export * from "./NotificationTray.vue?vue&type=script&lang=js"
import style0 from "./NotificationTray.vue?vue&type=style&index=0&id=4e137687&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports